import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.css'],
})
export class ModalConfirmComponent implements AfterViewChecked {
  @Input() modalConfirm: boolean;
  @Input() header: string;
  @Input() message: string;
  @Output() modalConfirmChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onModalAction: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('cancelButton') cancelButton: ElementRef;

  constructor() { }

  ngAfterViewChecked(): void {
    if (this.cancelButton && this.cancelButton.nativeElement) {
      this.cancelButton.nativeElement.focus();
    }
  }

  cancelClick() {
    this.modalConfirm = false;
    this.modalConfirmChange.emit(this.modalConfirm);
    this.onModalAction.emit({ type: 'cancel' });
  }

  okClick() {
    this.modalConfirm = false;
    this.onModalAction.emit({ type: 'OK' });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-confirm/modal-confirm.component.ts